import { NgModule } from '@angular/core';

import { MetaGuard } from './guards/meta.guard';
import { MetaService } from './services/meta.service';

@NgModule({
    providers: [
        MetaGuard,
        MetaService,
    ],
})

export class MetaModule {}
